/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type VendorDetailsRequestPriority = typeof VendorDetailsRequestPriority[keyof typeof VendorDetailsRequestPriority];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorDetailsRequestPriority = {
  new_vendor: 'new_vendor',
  super_preferred: 'super_preferred',
  preferred: 'preferred',
  internal: 'internal',
  disabled: 'disabled',
  owner_vendor: 'owner_vendor',
} as const;
